<ng-container *ngIf="(authService.permissions$ | async)?.isFreemium; else legacyHeader">
  <mpro-freemium-header></mpro-freemium-header>
</ng-container>
<ng-template #legacyHeader>
  <mpro-legacy-header></mpro-legacy-header>
</ng-template>
